module.exports = __webpack_public_path__ + "img/zhuanpan3.8f27d432.png";